import { FetchRequestError } from "./FetchRequestError";

export class FetchNotFoundError extends FetchRequestError {
  /**
   * Backend-intended user flow: the requested resource was not found (404)
   * and the dashboard already surfaces a translated user-facing modal via
   * `FetchErrorModal`, so the user has an actionable next step. Suppress
   * from RUM/Sentry to avoid inflating monitoring with non-actionable
   * events.
   */
  override isUnexpectedSystemError(): boolean {
    return false;
  }
}
